import { TypeGlobalNavFields } from '@/core/generated-types';

export function shouldShowMessageBanner({
  bannerText,
  bannerLinks,
  showAccessibilityLink,
}: Pick<
  TypeGlobalNavFields,
  'bannerText' | 'bannerLinks' | 'showAccessibilityLink'
>) {
  return (
    (bannerText && bannerText.content.length > 0) ||
    (bannerLinks && bannerLinks.length > 0) ||
    showAccessibilityLink === true
  );
}
